<template>
    <van-popup v-model:show="show" closeable position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        width: '100%',
        minHeight: '50%',
    }">
        <div class="share_pop">
            <div class="point_text">1. Convide amigos para ajudar com saques</div>
            <van-row class="share_items">
                <van-col span="4" class="share_item">
                    <div class="mais">
                        <img src="@/assets/sideNavbar/share.png" alt="">
                    </div>
                    <div class="share_name">Mais</div>
                </van-col>
                <van-col span="4" v-for="(item, index) in shareList" :key="index" class="share_item">
                    <div class="share_icon">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="share_name">{{ item.name }}</div>
                </van-col>
            </van-row>

            <van-row class="copy_row">
                <van-col span="20">https://688v.team/#/cashwheel?a=styk1ngs</van-col>
                <van-col span="4" class="copy_text"
                    @click="copyText('https://688v.team/#/cashwheel?a=styk1ngs')">Cópia</van-col>
            </van-row>

            <div class="point_text">2. Enviar convite para jogador aleatório ajudar</div>

            <van-row class="number_plate">
                <van-col span="5" v-for="i in resData.assists" :key="i" class="num_text">{{ i }}</van-col>
                <van-col span="12">
                    <van-row class="bg_2" justify="space-between">
                        <van-col span="17">Enviar Mensagem on <span>WhatsApp</span></van-col>
                        <van-col span="5"><img src="@/assets/sideNavbar/whatsapp.png" alt=""></van-col>
                    </van-row>
                </van-col>
                <van-col span="12">
                    <van-row class="bg_2" justify="space-between">
                        <van-col span="5"><img src="@/assets/sideNavbar/sms.png" alt=""></van-col> <van-col
                            span="17">Enviar Mensagem <span>SMS</span></van-col>
                    </van-row>
                </van-col>
            </van-row>
        </div>
    </van-popup>
    <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />

</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue'
import { ref, defineExpose } from 'vue'
const show = ref(false)
const shareList = ref([
    { img: require("@/assets/sideNavbar/facebook_cai.png"), name: 'Facebook' },
    { img: require("@/assets/sideNavbar/Whatsapp_cai.png"), name: 'WhatsApp' },
    { img: require("@/assets/sideNavbar/Telegram_cai.png"), name: 'Telegram' },
    { img: require("@/assets/sideNavbar/Twitter.png"), name: 'Twitter' },
    { img: require("@/assets/sideNavbar/email.png"), name: 'Email' }
])
const resData = ref({
    assists: [
        "5511991098602",
        "5511963002295",
        "5551998660068",
        "5541997293702",
        "5547989098177",
        "5531996699079",
        "5562999085639",
        "5531973177762",
        "5531999534506",
        "5562995036596",
        "5511952068120",
        "5561984570216",
        "5561998069429",
        "5541992261435",
        "5521972266621",
        "5541997813925",
        "5511951508833",
        "5511998837920",
        "5531989769510",
        "5551994074604"
    ]
})
const statusRef = ref()
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
const copyText = (value: string) => {
    if (value) {
        navigator.clipboard.writeText(value);
        statusRef.value.open();
    }
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.share_pop {
    padding: 15px;
}

.share_items {
    padding: 15px 0;
}

.share_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.point_text {
    color: #898989;
    font-size: 13px;
    font-weight: 600;
}

.share_icon img {
    width: 40px;
}

.mais {
    background-color: #1a9276;
    width: 35px;
    height: 35px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
}

.mais img {
    width: 20px;
    filter: invert(100%);
}

.share_name {
    font-size: 10px;
    padding: 5px;
    color: #727272;
}

.copy_row {
    color: grey;
    background-color: #f9f9f9;
    font-weight: 700;
    font-size: 10px;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;
}

.copy_text {
    color: #40a1de;
}

.van-overlay {
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
}

.number_plate {
    background: #000;
    color: #8f8f8f;
    padding: 5px;
    font-size: 10px;
    margin-top: 10px;
}

.num_text {
    padding: 3px;
    margin-right: 5px;
}

.bg_2 {
    background: #FFF;
    margin: 5Px;
    color: #000;
    font-size: 12px;
    font-weight: 600;
    padding: 5px;
}

.bg_2 img {
    width: 35px;
}

.bg_2 span {
    font-weight: 900;
}
</style>